import yup from "src/validators/yup.Module";

export interface TributacaoCadastroDto {
  id: number;
  nome: string;
  naturezaOperacao: string;
  tipoOperacao: number;
  tipoOperacaoDescricao: string;
  padraoEmissaoCupomFiscal: boolean;
}

export interface TributacaoCadastroCfopDto {
  id: number;
  tributacaoId: number;
  cfop: string;
  tipoParametro: number;
  tipoParametroDescricao: string;
  parametroValor: number;
  impostos: TributacaoCfopImpostoDto[];
}

export interface TributacaoCfopImpostoDto {
  id: number;
  tributacaoCFOPId: number;
  tipoImposto: number;
  tipoImpostoDescricao: string;
  cst: number;
  aliquotaSimples: string;
}

export const TributacaoCadastroSchema = yup.object().shape({
  nome: yup
    .string()
    .notRequired()
    .min(3, "O nome deve ter no mínimo 3 caracteres"),
});
